<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-10-21 13:13:42
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_Microsoft_FileDragUpdate.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-16 17:56:38
-->
<template>
  <v-container fluid class="pa-0 ma-0">
    <v-file-input
      id="fileInput"
      hide-input
      v-show="false"
      multiple
      accept="doc,docx,pdf,ppt,jpg,jpeg,png,xlsx,xls"
      @change="chooseUploadFile"
    ></v-file-input>
    <v-row dense align="center">
      <v-col xs="12" sm="12" md="12" lg="12" cols="12">
        <v-sheet class="text--secondary d-inline-block text-truncate">
          <span :class="labelClass" v-if="showLabel">{{ label }}</span>
        </v-sheet>
        <v-card
          class="rounded-lg"
          :style="{
            border:
              '2px dashed ' +
              (isRequire && isActive && fileList.length == 0
                ? 'red'
                : 'var(--main-border-color)'),
          }"
          elevation="0"
          v-if="!disabled"
          @dragover="fileDragover"
          @drop="fileDrop"
        >
          <v-sheet class="text-center align-center mrc-grey">
            <div>
              <i class="material-icons-round md-72 text--secondary lighten-2"
                >backup</i
              >
            </div>
            <div class="py-3">
              <span>{{ $t("label_essweb_update_components_tipLabel") }}</span>
              <v-btn
                color="primary lighten-2 "
                small
                rounded
                :disabled="disabled || (isSingle && fileUuids.length > 0)"
                class="text-capitalize ml-2"
                @click="toChoose"
                >{{
                  $t("label_essweb_update_components_browseBtnLabel")
                }}</v-btn
              >
            </div>
          </v-sheet>
        </v-card>
      </v-col>
      <v-sheet
        class="red--text px-1"
        v-if="isRequire && isActive && fileList.length == 0"
        >{{
          $t("verify_essweb_form_textField_dataCommonLabel") +
          $t("verify_essweb_form_textField_textisNullTextLabel")
        }}</v-sheet
      >
      <v-col xs="12" sm="12" md="12" lg="12" cols="12" v-if="fileList.length">
        <v-container
          class="scroll_content_y pa-0 ma-0"
          :style="{ maxHeight: '214px' }"
        >
          <v-sheet
            style="position: relative"
            class="rounded-lg my-2 mrc-border-solid"
            v-for="(item, index) in fileList"
            :key="`file--${index}---${item.id}`"
          >
            <v-progress-linear
              v-if="item.uploading"
              absolute
              :style="{ top: 0, zIndex: 0 }"
              height="100%"
              background-opacity="0"
              v-model="item.progress"
              class="rounded-lg"
              :buffer-value="100"
              color="primary lighten-3"
            ></v-progress-linear>
            <v-sheet
              class="text-left align-center d-flex transparent px-2 py-2"
              :style="{ zIndex: 1, position: 'relative' }"
            >
              <svg-icon
                size="32"
                :fill="item.updated ? '#0f46c1' : 'grey'"
                :iconClass="
                  item.file_type == 'jpg'
                    ? 'filetype-jpg'
                    : item.file_type == 'csv'
                    ? 'filetype-csv'
                    : item.file_type == 'doc'
                    ? 'filetype-doc'
                    : item.file_type == 'gif'
                    ? 'filetype-gif'
                    : item.file_type == 'png'
                    ? 'filetype-png'
                    : item.file_type == 'xls'
                    ? 'filetype-xls'
                    : item.file_type == 'docx'
                    ? 'filetype-doc'
                    : item.file_type == 'xlsx'
                    ? 'filetype-xls'
                    : item.file_type == 'pdf'
                    ? 'filetype-pdf'
                    : item.file_type == 'ppt'
                    ? 'filetype-ppt'
                    : item.file_type == 'jpeg'
                    ? 'filetype-jpg'
                    : 'filetype-file'
                "
              />
              <v-sheet
                class="
                  text-subtitle-2
                  px-1
                  transparent
                  text-left
                  align-center
                  d-flex
                "
              >
                <v-sheet
                  :style="{ maxWidth: '90%' }"
                  :title="item.filename"
                  class="text-subtitle-2 transparent text-truncate"
                  :class="item.updated_fail ? 'red--text' : 'text--primary'"
                >
                  {{ item.filename }}
                </v-sheet>

                <span class="text--secondary text-caption px-1"
                  >({{ $byteconvert(item.size) }})</span
                >
              </v-sheet>
              <v-spacer></v-spacer>
              <v-btn
                small
                icon
                @click="deleteItem(item.id, item)"
                v-if="!disabled"
              >
                <span class="material-icons-round">delete</span>
              </v-btn>
              <v-btn small v-else icon @click="toUrl(item)">
                <span class="material-icons-round">visibility</span>
              </v-btn>
            </v-sheet>
          </v-sheet>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import dayjs from "dayjs";
export default {
  name: "MicroSoft_FileUpdate",
  props: {
    label: { default: "", type: [String, Object, Number] },
    showLabel: { default: true, type: [Boolean, Number] },
    isRequire: { default: false, type: [Boolean, Number] },
    isSingle: { default: false, type: [Boolean, Number] },
    disabled: { default: false, type: [Boolean, Number] },
    validate: { default: false, type: [Number, Boolean] },
    defaultImageList: {
      default: function () {
        return [];
      },
      type: [Array, String, Object],
    },
  },
  computed: {
    ...mapGetters(["AppInfo", "companyLang", "defaultLang"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    labelClass() {
      let cla = "";
      if (this.isRequire) {
        cla += " mrc_text_require";
      }
      if (this.isRequire && this.isActive && this.fileList.length == 0) {
        cla += " red--text";
      }

      return cla;
    },
    fileUuids() {
      let arr = [];
      this.fileList.map((item) => {
        if (item.updated && item.uuid) {
          arr.push(item.uuid);
        }
      });
      return arr;
    },

    isActive() {
      let active = false;
      if (this.active == true) return true;
      if (this.fileList.length > 0) {
        this.active = true;
        active = true;
      }
      return active;
    },
    isError() {
      return this.isRequire && this.isActive && this.fileList.length == 0;
    },
  },
  data() {
    return {
      fileList: [],
      uploading: false,
      active: false,
    };
  },
  mounted() {
    //初始化
    if (this.defaultImageList.length) {
      const that = this;
      let val = this.defaultImageList;
      if (val == null || val == "") return;
      if (this.fileList.length) return;
      if (
        Object.prototype.toString.call(val).toLowerCase() ===
          "[object array]" &&
        val.length === 0
      ) {
        // 空数组
        return false;
      }
      this.fileList = [];
      if (val)
        if (
          typeof val == "object" &&
          Object.prototype.toString.call(val).toLowerCase() ==
            "[object object]" &&
          !val.length
        ) {
          this.fileList = [
            {
              id: val["uuid"] ? val["uuid"] : dayjs().valueOf(),
              filename: val.file_name,
              size: Number(val.size),
              save: val.save ? val.save : false,
              file: null,
              uploading: false,
              imageUrl: val.path,
              updated: true,
            },
          ];
        } else {
          if (val.length == 0) return;
          val.forEach((item, index) => {
            that.fileList.push({
              id: item["uuid"] ? item["uuid"] : dayjs().valueOf(),
              filename: item.file_name,
              size: Number(item.size),
              save: item.save ? item.save : false,
              image: item,
              file: null,
              uploading: false,
              imageUrl: item.path,
              updated: true,
            });
          });
        }
    }
  },
  watch: {
    validate(val) {
      //手动激活验证
      if (val) this.active = true;
    },
    isError(val) {
      this.$emit("error", val);
    },
    fileUuids(val) {
      this.$emit("change", val);
    },
    fileList(val) {
      const that = this;
      val.some((item) => {
        if (!item.updated && !item.updated_fail) {
          that.toUpdate(item.file, item.id);
          return true;
        }
      });
    },
    uploading(val) {
      if (!val) {
        const that = this;
        that.fileList.some((item) => {
          if (!item.updated && !item.updated_fail) {
            that.toUpdate(item.file, item.id);
            return true;
          }
        });
      }
    },
    defaultImageList(val, old) {
      const that = this;
      if (val == null || val == "") return;
      if (this.fileList.length) return;
      if (
        Object.prototype.toString.call(val).toLowerCase() ===
          "[object array]" &&
        val.length === 0
      ) {
        // 空数组
        return false;
      }
      this.fileList = [];
      if (val)
        if (
          typeof val == "object" &&
          Object.prototype.toString.call(val).toLowerCase() ==
            "[object object]" &&
          !val.length
        ) {
          this.fileList = [
            {
              id: val["uuid"] ? val["uuid"] : dayjs().valueOf(),
              filename: val.file_name,
              size: Number(val.size),
              file: null,
              save: val.save ? val.save : false,
              uploading: false,
              imageUrl: val.path,
              updated: true,
            },
          ];
        } else {
          if (val.length == 0) return;
          val.forEach((item, index) => {
            that.fileList.push({
              id: item["uuid"] ? item["uuid"] : dayjs().valueOf(),
              filename: item.file_name,
              size: Number(item.size),
              image: item,
              save: item.save ? item.save : false,
              file: null,
              uploading: false,
              imageUrl: item.path,
              updated: true,
            });
          });
        }
    },
  },
  methods: {
    toUrl: function (item) {
      if (item.imageUrl) location.href = item.imageUrl;
    },
    chooseUploadFile: function (file) {
      const that = this;

      if (!file) return;
      new Promise((resolve, reject) => {
        file.some((item) => {
          if (!/\.(docx|pdf|jpg|jpeg|ppt|png|xls|xlsx|doc)$/.test(item.name)) {
            that.$showMessage({
              type: "error",
              color: "error",
              text:
                that.$t("message_essweb_update_components_onlyUpdateLabel") +
                "doc,docx,pdf,ppt,jpg,jpeg,png,xlsx,xls" +
                "<br/>" +
                item.name,
            });

            resolve(false);
            return true;
          }
          if (item.size > 5 * 1000 * 1000) {
            that.$showMessage({
              type: "error",
              color: "error",
              text:
                that.$t("message_essweb_update_components_sizeLessThanLabel") +
                "5MB.",
            });
            resolve(false);
            return true;
          }
        });
        resolve(true);
      }).then((res) => {
        if (res) {
          file.map((item, index) => {
            that.fileList.push({
              id: dayjs().valueOf() + " " + index,
              filename: item.name,
              uuid: null,
              size: item.size,
              file: item,
              online_file: null,
              progress: 0,
              file_type: item.name.substring(
                item.name.lastIndexOf(".") + 1,
                item.name.length
              ),
              Url: "",
              updated_fail: false,
              uploading: false,
              updated: false,
            });
          });
        }
      });

      // if (file.length == 1) {
      //   //单个文件上传
      //   this.fileList.push({
      //     id: dayjs().valueOf(),
      //     filename: file.name,
      //     uuid: null,
      //     size: file.size,
      //     file: file,
      //     online_file: null,
      //     progress: 0,
      //     file_type: file.name.substring(
      //       file.name.lastIndexOf(".") + 1,
      //       file.name.length
      //     ),
      //     Url: "",
      //     uploading: false,
      //     updated: false,
      //   });
      // }
    },
    fileDragover: function (e) {
      e.preventDefault();
    },

    deleteItem: function (id, item) {
      const that = this;
      that.bindAvatar("", item.uuid).then((res) => {
        that.fileList = that.fileList.filter((ele) => ele.id !== id);
      });
    },
    fileDrop: function (e) {
      e.preventDefault();
      const that = this;
      if (this.disabled) return;
      if (this.isSingle && this.fileUuids.length == 1) return;
      // if (e.dataTransfer.files.length > 1) {
      //   this.$showMessage({
      //     type: "error",
      //     color: "error",
      //     text: this.$t("message_essweb_update_components_onlyUpdateOneLabel"),
      //   });
      //   return false;
      // }
      var file = [];
      for (let index = 0; index < e.dataTransfer.files.length; index++) {
        file.push(e.dataTransfer.files[index]);
      }
      if (!file) return;
      new Promise((resolve, reject) => {
        file.some((item) => {
          if (!/\.(docx|pdf|jpg|jpeg|ppt|png|xls|xlsx|doc)$/.test(item.name)) {
            that.$showMessage({
              type: "error",
              color: "error",
              text:
                that.$t("message_essweb_update_components_onlyUpdateLabel") +
                "doc,docx,pdf,ppt,jpg,jpeg,png,xlsx,xls" +
                "<br/>" +
                item.name,
            });

            resolve(false);
            return true;
          }
          if (item.size > 5 * 1000 * 1000) {
            that.$showMessage({
              type: "error",
              color: "error",
              text:
                that.$t("message_essweb_update_components_sizeLessThanLabel") +
                "5MB.",
            });
            resolve(false);
            return true;
          }
        });
        resolve(true);
      }).then((res) => {
        if (res) {
          file.map((item, index) => {
            that.fileList.push({
              id: dayjs().valueOf() + " " + index,
              filename: item.name,
              uuid: null,
              size: item.size,
              file: item,
              online_file: null,
              progress: 0,
              file_type: item.name.substring(
                item.name.lastIndexOf(".") + 1,
                item.name.length
              ),
              Url: "",
              updated_fail: false,
              uploading: false,
              updated: false,
            });
          });
        }
      });
    },

    toChoose: function () {
      if (this.isSingle && this.fileUuids.length == 1) return;
      $("#fileInput").click();
    },
    setFileArgs(id, obj) {
      const that = this;
      return new Promise((resolve, reject) => {
        that.fileList.map((item, index) => {
          if (item.id === id) {
            for (let key in obj) {
              if (item[key] !== undefined) item[key] = obj[key];
            }
          }
          if (index == that.fileList.length - 1) resolve(true);
        });
      });
    },
    getUploadInfo: function (name, size, curId) {
      const that = this;
      that.setFileArgs(curId, { uploading: true, progress: 15 });
      that.uploading = true;
      return new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/fileManager/add-file-record-plan/",
            data: {
              module_uuid: "payslip",
              attachment_data_field: that.curAppInfo["user"]["thumbnail_img"],
              org_level_uuid: that.curAppInfo["user"]["org_level_uuid"],
              attachment_title: name,
              attachment_size: size,
            },
            type: "upload",
            global: false,
          })
          .then((res) => {
            that.setFileArgs(curId, { uploading: false, progress: 23 });
            reslove(res);
          })
          .catch((err) => {
            that
              .setFileArgs(curId, {
                uploading: false,
                progress: 0,
                updated_fail: true,
              })
              .then((result) => {
                that.uploading = false;
              });
            reject(err);
          });
      });
    },
    //删除图片
    async bindAvatar(uuid, del = "") {
      const that = this;
      return await new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/staff-manager/upload_staff_avatar/",
            data: {
              user_id: that.curAppInfo["user"]["user_id"],
              uuid: that.curAppInfo["user"]["uuid"],
              thumbnail_img: uuid,
              del: del,
            },
            type: "upload",
            global: false,
          })
          .then((res) => {
            reslove(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async onUploadAvatar(uuid, curId) {
      const that = this;
      that.setFileArgs(curId, { uploading: true, progress: 84 });
      return await new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/fileManager/get-file-info/",
            data: { uuid: uuid },
            type: "upload",
            global: false,
          })
          .then((res) => {
            that.setFileArgs(curId, { uploading: false, progress: 99 });
            reslove(res);
          })
          .catch((err) => {
            that
              .setFileArgs(curId, {
                uploading: false,
                progress: 0,
                updated_fail: true,
              })
              .then((result) => {
                that.uploading = false;
              });
            reject(err);
          });
      });
    },
    async UploadAvatar(file, arg, curId) {
      const that = this;
      that.setFileArgs(curId, { uploading: true, progress: 25 });
      return await new Promise((reslove, reject) => {
        that.$azureUpload(
          {
            baseUrl: arg.upload_url.split("?")[0],
            sasToken: arg.sostoken,
            file: file,
            progress: (progress) => {},
            complete: (res) => {
              that.setFileArgs(curId, { uploading: false, progress: 45 });
              reslove(true);
            },
            error: (err) => {
              that
                .setFileArgs(curId, {
                  uploading: false,
                  progress: 0,
                  updated_fail: true,
                })
                .then((result) => {
                  that.uploading = false;
                });
              reject(err);
            },
            blockSize: file.size,
          },
          axios.create()
        );
      });
    },
    async callBackUpload(result, uuid, curId) {
      const that = this;
      that.setFileArgs(curId, { uploading: true, progress: 52 });
      return new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/fileManager/add-file-callback/",
            data: {
              result: result,
              uuid: uuid,
            },
            type: "upload",
            global: false,
          })
          .then((res) => {
            that.setFileArgs(curId, { uploading: false, progress: 78 });
            reslove(res);
          })
          .catch((err) => {
            that
              .setFileArgs(curId, {
                uploading: false,
                progress: 0,
                updated_fail: true,
              })
              .then((result) => {
                that.uploading = false;
              });
            reject(err);
          });
      });
    },
    async toUpdate(file, id) {
      const that = this;
      await that
        .getUploadInfo(file.name, file.size, id)
        .then((res) => {
          that
            .UploadAvatar(file, res.data, id)
            .then((result) => {
              if (result === true) {
                that
                  .callBackUpload(1, res.data.uuid, id)
                  .then((resu) => {
                    if (resu.data.type == "update") {
                      that
                        .onUploadAvatar(res.data.uuid, id)
                        .then((resul) => {
                          // 上传成功
                          that
                            .setFileArgs(id, {
                              updated: true,
                              uuid: resul.data["files"][0].uuid,
                              online_file: resul.data["files"][0],
                              Url: resul.data["files"][0].path,
                            })
                            .then((result) => {
                              that.uploading = false;
                            });
                        })
                        .catch((err) => {
                          that.uploading = false;
                        });
                    } else {
                      //上报失败
                    }
                  })
                  .catch((err) => {
                    console.log(err); //上报失败
                  });
              }
            })
            .catch((err) => {
              // 上传失败
              console.log(err);
              that.callBackUpload(0, res.data.uuid, id);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>